<template>
  <h1>Chat Layout</h1>
</template>